import axios from 'axios';
import { getApiBaseUrl } from '../config/apiBase';

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 审批流「流程测试」开关：开启后请求会带上 x-workflow-test 头，
// 由后端在测试上下文内跳过业务发起权限校验。
let workflowTestMode = false;
export function setWorkflowTestMode(on) {
  workflowTestMode = !!on;
}

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['x-platform'] = 'admin';
    if (workflowTestMode) {
      config.headers['x-workflow-test'] = '1';
    }
    // FormData 须由浏览器/axios 自动带 boundary，不能沿用默认 application/json
    if (config.data instanceof FormData) {
      if (typeof config.headers?.delete === 'function') {
        config.headers.delete('Content-Type');
      } else {
        delete config.headers['Content-Type'];
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    } else if (error.response?.status === 403) {
      const msg = error.response?.data?.message || '无权限访问此功能';
      if (!error.config?.skipErrorMessage) {
        console.warn('[403]', msg, error.config?.url);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
